import { writable } from "svelte/store";
import { call } from "$lib/Api/Api.svelte";

const classes = writable([]);

const classStore = {
  subscribe: classes.subscribe,
  load: (id) => {
    return call("classes", "query")
      .then((data) => {
        classes.set(data);
      })
      .catch((err) => {});
  },
};

export default classStore;
